import { Injectable } from '@angular/core';
import { Employee } from 'src/app/workflow/benefits/commons/interfaces/benefit-body.interface';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  data: Employee[] = [];
  dataRequestForm:any;

  setEmployee(data: Employee[]): void {
    this.data = data;
  }

  getBrokerRol() {
    return this.data[0].isBroker;
  }

  setDataRequest(request:any){
    this.dataRequestForm = request;
  }

  getDataRequest(){
    return this.dataRequestForm;
  }
}
